import React, { useEffect, useState } from 'react';
import { supabase } from './supabase';
import { DollarSign, Plus, Edit, Trash2, Package, AlertCircle, AlertTriangle, CheckCircle2 } from 'lucide-react';

export default function ProveedoresCambioTab({ constructora, showCustomAlert }) {
  const [proveedores, setProveedores] = useState([]);
  const [proveedoresEliminados, setProveedoresEliminados] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editandoProveedor, setEditandoProveedor] = useState(null);
  const [formData, setFormData] = useState({ nombre: '' });
  const [guardando, setGuardando] = useState(false);
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' ? window.innerWidth <= 768 : true);
  const [activeTab, setActiveTab] = useState('activos');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [proveedorSeleccionado, setProveedorSeleccionado] = useState(null);
  const [analisisImpacto, setAnalisisImpacto] = useState(null);
  const [showModal3Opciones, setShowModal3Opciones] = useState(false);
  const [opcionesEdicion, setOpcionesEdicion] = useState(null);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const cargarProveedores = async () => {
    try {
      const { data, error } = await supabase
        .from('proveedores_cambio')
        .select('*')
        .eq('constructora_id', constructora.id)
        .order('nombre');
      if (error) throw new Error(error.message);
      const todos = data || [];
      const activos = todos.filter(p => (p.activo === true) && p.deleted_at === null);
      const eliminados = todos.filter(p => (p.activo === false) || p.deleted_at !== null);
      setProveedores(activos);
      setProveedoresEliminados(eliminados);
    } catch (e) {
      console.error('Error cargando proveedores_cambio:', e);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (constructora?.id) cargarProveedores();
  }, [constructora?.id]);

  useEffect(() => {
    const onEsc = (e) => {
      if (e.key === 'Escape') {
        if (showModal) setShowModal(false);
        if (showDeleteModal) setShowDeleteModal(false);
        if (showModal3Opciones) setShowModal3Opciones(false);
      }
    };
    if (showModal || showDeleteModal || showModal3Opciones) {
      document.addEventListener('keydown', onEsc);
      return () => document.removeEventListener('keydown', onEsc);
    }
  }, [showModal, showDeleteModal, showModal3Opciones]);

  const abrirModal = (prov = null) => {
    if (prov) {
      setEditandoProveedor(prov);
      setFormData({ nombre: prov.nombre });
    } else {
      setEditandoProveedor(null);
      setFormData({ nombre: '' });
    }
    setShowModal(true);
  };

  const guardarProveedor = async () => {
    if (!formData.nombre.trim()) {
      showCustomAlert('error', 'Error', 'Por favor ingresa un nombre');
      return;
    }
    setGuardando(true);
    try {
      if (editandoProveedor && formData.nombre.trim() !== editandoProveedor.nombre.trim()) {
        const resp = await fetch('http://localhost:4001/api/proveedores-cambio/analizar-impacto', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ proveedor_id: editandoProveedor.id, accion: 'editar', cambios: { nombre: formData.nombre.trim() } })
        });
        const data = await resp.json();
        if (data.success && data.impacto?.cambios?.total_cambios > 0) {
          setOpcionesEdicion({ proveedor_id: editandoProveedor.id, cambios: { nombre: formData.nombre.trim() }, impacto: data.impacto });
          setShowModal3Opciones(true);
          setShowModal(false);
          setGuardando(false);
          return;
        }
      }

      if (editandoProveedor) {
        const { error } = await supabase
          .from('proveedores_cambio')
          .update({ nombre: formData.nombre.trim(), updated_by: constructora.usuario_id || null })
          .eq('id', editandoProveedor.id);
        if (error) throw new Error(error.message);
      } else {
        const { error } = await supabase
          .from('proveedores_cambio')
          .insert([{ constructora_id: constructora.id, nombre: formData.nombre.trim(), activo: true, created_by: constructora.usuario_id || null }]);
        if (error) throw new Error(error.message);
      }
      setShowModal(false);
      setEditandoProveedor(null);
      setFormData({ nombre: '' });
      await cargarProveedores();
      showCustomAlert('success', 'Éxito', editandoProveedor ? 'Proveedor actualizado' : 'Proveedor creado');
    } catch (e) {
      console.error(e);
      showCustomAlert('error', 'Error', e.message);
    }
    setGuardando(false);
  };

  const ejecutarOpcionEdicion = async (opcion) => {
    setGuardando(true);
    try {
      let r;
      if (opcion === 'incluir_pasados') {
        r = await fetch('http://localhost:4001/api/proveedores-cambio/editar', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ proveedor_id: opcionesEdicion.proveedor_id, cambios: opcionesEdicion.cambios, usuario_id: constructora.usuario_id }) });
      } else if (opcion === 'solo_futuros' || opcion === 'crear_nuevo') {
        r = await fetch('http://localhost:4001/api/proveedores-cambio/crear-nuevo', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ proveedor_id_viejo: opcionesEdicion.proveedor_id, nuevo_proveedor: { nombre: opcionesEdicion.cambios.nombre, constructora_id: constructora.id }, usuario_id: constructora.usuario_id }) });
      }
      const res = await r.json();
      if (!res.success) throw new Error(res.error || 'Error aplicando opción');
      setShowModal3Opciones(false);
      setOpcionesEdicion(null);
      setFormData({ nombre: '' });
      await cargarProveedores();
      showCustomAlert('success', 'Éxito', 'Proveedor actualizado');
    } catch (e) {
      console.error(e);
      showCustomAlert('error', 'Error', e.message);
    }
    setGuardando(false);
  };

  const eliminarProveedor = async (id, nombre) => {
    try {
      const r = await fetch('http://localhost:4001/api/proveedores-cambio/eliminar', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ proveedor_id: id, confirmar: false }) });
      const analisis = await r.json();
      if (!analisis.success) throw new Error(analisis.error || 'Error analizando impacto');
      setProveedorSeleccionado({ id, nombre });
      setAnalisisImpacto(analisis.data?.impacto || analisis.impacto || null);
      setShowDeleteModal(true);
    } catch (e) {
      console.error(e);
      showCustomAlert('error', 'Error', e.message);
    }
  };

  const ejecutarEliminacion = async () => {
    setGuardando(true);
    try {
      const r = await fetch('http://localhost:4001/api/proveedores-cambio/eliminar', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ proveedor_id: proveedorSeleccionado.id, confirmar: true, usuario_id: constructora.usuario_id }) });
      const res = await r.json();
      if (!res.success) throw new Error(res.error || 'Error al eliminar');
      setShowDeleteModal(false);
      setProveedorSeleccionado(null);
      setAnalisisImpacto(null);
      await cargarProveedores();
      showCustomAlert('success', 'Éxito', 'Proveedor eliminado');
    } catch (e) {
      console.error(e);
      showCustomAlert('error', 'Error', e.message);
    }
    setGuardando(false);
  };

  const restaurarProveedor = async (id) => {
    try {
      const r = await fetch('http://localhost:4001/api/proveedores-cambio/restaurar', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ proveedor_id: id, usuario_id: constructora.usuario_id }) });
      const res = await r.json();
      if (!res.success) throw new Error(res.error || 'Error al restaurar');
      await cargarProveedores();
      showCustomAlert('success', 'Éxito', 'Proveedor restaurado');
    } catch (e) {
      console.error(e);
      showCustomAlert('error', 'Error', e.message);
    }
  };

  return (
    <div style={{padding: isMobile ? '20px 16px' : '24px 32px'}}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '24px', flexWrap: 'wrap', gap: '16px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1 }}>
          <div style={{ width: '32px', height: '32px', background: '#2563eb15', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <DollarSign size={18} color="#2563eb" />
          </div>
          <div>
            <h2 style={{ fontSize: isMobile ? '18px' : '20px', fontWeight: '600', color: '#1e293b', margin: '0 0 4px 0' }}>Proveedores de Cambio</h2>
            <p style={{ fontSize: '13px', color: '#64748b', margin: 0 }}>Gestiona casas de cambio para operaciones en divisas</p>
          </div>
        </div>
        <button 
          onClick={() => abrirModal()}
          style={{
            background: 'linear-gradient(135deg, #2563eb 0%, #2563eb 100%)',
            color: 'white',
            border: 'none',
            padding: isMobile ? '10px 16px' : '12px 20px',
            borderRadius: '10px',
            fontSize: isMobile ? '13px' : '14px',
            fontWeight: '600',
            cursor: 'pointer',
            boxShadow: '0 4px 16px rgba(37, 99, 235, 0.25)',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)'
          }}
          className="button-hover"
        >
          <Plus size={16} />
          Añadir proveedor
        </button>
      </div>

      {loading ? (
        <p style={{ color: '#64748b' }}>Cargando proveedores...</p>
      ) : (
        <>
          {/* Tabs */}
          <div style={{
            display: 'flex',
            borderBottom: '2px solid #e5e7eb',
            marginBottom: '24px',
            gap: '0',
            position: 'relative'
          }}>
            <button
              onClick={() => setActiveTab('activos')}
              style={{
                background: 'transparent',
                border: 'none',
                padding: '12px 24px',
                fontSize: '14px',
                fontWeight: '600',
                cursor: 'pointer',
                color: activeTab === 'activos' ? '#10b981' : '#6b7280',
                borderBottom: activeTab === 'activos' ? '2px solid #10b981' : '2px solid transparent',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                flex: 1,
                textAlign: 'center',
                position: 'relative',
                zIndex: 2
              }}
              onMouseEnter={(e) => {
                if (activeTab !== 'activos') {
                  e.target.style.color = '#10b981';
                  e.target.style.borderBottom = '2px solid #10b981';
                }
              }}
              onMouseLeave={(e) => {
                if (activeTab !== 'activos') {
                  e.target.style.color = '#6b7280';
                  e.target.style.borderBottom = '2px solid transparent';
                }
              }}
            >
              Activos ({proveedores.length})
            </button>
            <button
              onClick={() => setActiveTab('eliminados')}
              style={{
                background: 'transparent',
                border: 'none',
                padding: '12px 24px',
                fontSize: '14px',
                fontWeight: '600',
                cursor: 'pointer',
                color: activeTab === 'eliminados' ? '#ef4444' : '#6b7280',
                borderBottom: activeTab === 'eliminados' ? '2px solid #ef4444' : '2px solid transparent',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                flex: 1,
                textAlign: 'center',
                position: 'relative',
                zIndex: 2
              }}
              onMouseEnter={(e) => {
                if (activeTab !== 'eliminados') {
                  e.target.style.color = '#ef4444';
                  e.target.style.borderBottom = '2px solid #ef4444';
                }
              }}
              onMouseLeave={(e) => {
                if (activeTab !== 'eliminados') {
                  e.target.style.color = '#6b7280';
                  e.target.style.borderBottom = '2px solid transparent';
                }
              }}
            >
              Eliminados ({proveedoresEliminados.length})
            </button>
          </div>

          <div style={{
            background: 'white',
            border: '1px solid #f1f5f9',
            borderRadius: '12px',
            overflow: 'hidden'
          }}>
          <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: isMobile ? '600px' : '900px' }}>
            <thead>
              <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                <th style={{ padding: isMobile ? '12px 16px' : '16px 20px', textAlign: 'left', fontWeight: 600, color: '#374151', fontSize: isMobile ? '12px' : '14px' }}>Nombre</th>
                <th style={{ padding: isMobile ? '12px 16px' : '16px 20px', textAlign: 'left', fontWeight: 600, color: '#374151', fontSize: isMobile ? '12px' : '14px' }}>Fecha</th>
                <th style={{ padding: isMobile ? '12px 16px' : '16px 20px', textAlign: 'center', fontWeight: 600, color: '#374151', fontSize: isMobile ? '12px' : '14px', width: isMobile ? '120px' : '160px' }}>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {(activeTab === 'activos' ? proveedores : proveedoresEliminados).map((p, index, arr) => (
                <tr key={p.id} style={{ borderBottom: index < arr.length - 1 ? '1px solid #f1f5f9' : 'none', transition: 'background-color 0.2s ease' }}>
                  <td style={{ padding: isMobile ? '12px 16px' : '16px 20px', color: '#1e293b', fontSize: isMobile ? '13px' : '14px', fontWeight: 600 }}>{p.nombre}</td>
                  <td style={{ padding: isMobile ? '12px 16px' : '16px 20px', color: '#64748b', fontSize: isMobile ? '11px' : '12px' }}>{new Date(p.created_at).toLocaleDateString('es-AR')}</td>
                  <td style={{ padding: '16px', textAlign: 'center' }}>
                    {activeTab === 'activos' ? (
                      <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                        <button 
                          onClick={() => abrirModal(p)}
                          style={{
                            background: '#eff6ff',
                            border: '1px solid #3b82f6',
                            borderRadius: '6px',
                            padding: '8px 12px',
                            color: '#3b82f6',
                            fontSize: '12px',
                            fontWeight: 500,
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px',
                            transition: 'all 0.2s ease'
                          }}
                          onMouseEnter={(e) => { e.target.style.background = '#dbeafe'; }}
                          onMouseLeave={(e) => { e.target.style.background = '#eff6ff'; }}
                        >
                          <Edit size={12} />
                          Editar
                        </button>
                        <button 
                          onClick={() => eliminarProveedor(p.id, p.nombre)}
                          style={{
                            background: '#fef2f2',
                            border: '1px solid #ef4444',
                            borderRadius: '6px',
                            padding: '8px 12px',
                            color: '#ef4444',
                            fontSize: '12px',
                            fontWeight: 500,
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px',
                            transition: 'all 0.2s ease'
                          }}
                          onMouseEnter={(e) => { e.target.style.background = '#fee2e2'; }}
                          onMouseLeave={(e) => { e.target.style.background = '#fef2f2'; }}
                        >
                          <Trash2 size={12} />
                          Eliminar
                        </button>
                      </div>
                    ) : (
                      <button 
                        onClick={() => restaurarProveedor(p.id)}
                        style={{
                          background: '#f0fdf4',
                          border: '1px solid #22c55e',
                          borderRadius: '6px',
                          padding: '8px 12px',
                          color: '#22c55e',
                          fontSize: '12px',
                          fontWeight: 500,
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '4px',
                          transition: 'all 0.2s ease'
                        }}
                        onMouseEnter={(e) => { e.target.style.background = '#dcfce7'; }}
                        onMouseLeave={(e) => { e.target.style.background = '#f0fdf4'; }}
                      >
                        <Package size={12} />
                        Restaurar
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </div>
        </>
      )}

      {showModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000,
          padding: isMobile ? '20px' : '0',
          animation: 'fadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
        }}>
          <div style={{
            background: 'white',
            borderRadius: '16px',
            padding: isMobile ? '20px' : '24px',
            width: isMobile ? '100%' : '500px',
            maxWidth: '90vw',
            maxHeight: '90vh',
            overflowY: 'auto',
            boxShadow: '0 25px 80px rgba(0,0,0,0.3)',
            animation: 'scaleIn 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              marginBottom: '20px'
            }}>
              <div style={{
                width: '32px',
                height: '32px',
                background: '#2563eb15',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <DollarSign size={18} color="#2563eb" />
              </div>
              <h3 style={{
                margin: 0,
                fontSize: isMobile ? '18px' : '20px',
                fontWeight: '700',
                color: '#1e293b'
              }}>
                {editandoProveedor ? 'Editar' : 'Nuevo'} Proveedor
              </h3>
            </div>
            
            <div style={{
              display: 'grid',
              gap: '16px'
            }}>
              <div>
                <label style={{
                  display: 'block',
                  marginBottom: '8px',
                  fontSize: '14px',
                  fontWeight: '600',
                  color: '#374151'
                }}>
                  Nombre del Proveedor *
                </label>
                <input
                  type="text"
                  placeholder="Ej: Casa Piano, Cambio Flores, etc."
                  value={formData.nombre}
                  onChange={(e) => setFormData({...formData, nombre: e.target.value})}
                  style={{
                    width: '100%',
                    padding: '14px 16px',
                    border: '2px solid #f1f5f9',
                    borderRadius: '10px',
                    fontSize: '16px',
                    boxSizing: 'border-box',
                    outline: 'none',
                    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                    touchAction: 'manipulation'
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#2563eb';
                    e.target.style.boxShadow = '0 0 0 3px rgba(37, 99, 235, 0.1)';
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#f1f5f9';
                    e.target.style.boxShadow = 'none';
                  }}
                />
              </div>
            </div>

            <div style={{
              display: 'flex',
              gap: '12px',
              justifyContent: 'flex-end',
              marginTop: '24px'
            }}>
              <button
                onClick={() => setShowModal(false)}
                disabled={guardando}
                style={{
                  padding: '12px 20px',
                  border: '2px solid #e2e8f0',
                  borderRadius: '10px',
                  background: 'white',
                  color: '#64748b',
                  fontSize: '14px',
                  fontWeight: '600',
                  cursor: guardando ? 'not-allowed' : 'pointer',
                  transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                  opacity: guardando ? 0.6 : 1
                }}
                onMouseEnter={(e) => !guardando && (e.target.style.background = '#f8fafc')}
                onMouseLeave={(e) => !guardando && (e.target.style.background = 'white')}
              >
                Cancelar
              </button>
              <button
                onClick={guardarProveedor}
                disabled={guardando}
                style={{
                  padding: '12px 20px',
                  border: 'none',
                  borderRadius: '10px',
                  background: guardando ? '#9ca3af' : 'linear-gradient(135deg, #2563eb 0%, #2563eb 100%)',
                  color: 'white',
                  fontSize: '14px',
                  fontWeight: '600',
                  cursor: guardando ? 'not-allowed' : 'pointer',
                  transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                  boxShadow: guardando ? 'none' : '0 4px 16px rgba(37, 99, 235, 0.25)',
                  transform: guardando ? 'none' : 'translateY(0)'
                }}
                onMouseEnter={(e) => !guardando && (e.target.style.transform = 'translateY(-1px)')}
                onMouseLeave={(e) => !guardando && (e.target.style.transform = 'translateY(0)')}
                onMouseDown={(e) => !guardando && (e.target.style.transform = 'translateY(0)')}
                onMouseUp={(e) => !guardando && (e.target.style.transform = 'translateY(-1px)')}
              >
                {guardando ? 'Guardando...' : (editandoProveedor ? 'Actualizar' : 'Guardar')}
              </button>
            </div>
          </div>
        </div>
      )}

      {showModal3Opciones && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000,
          padding: isMobile ? '20px' : '0',
          animation: 'fadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
        }}>
          <div style={{
            background: 'white',
            borderRadius: '16px',
            padding: isMobile ? '20px' : '24px',
            width: isMobile ? '100%' : '500px',
            maxWidth: '90vw',
            maxHeight: '90vh',
            overflowY: 'auto',
            boxShadow: '0 25px 80px rgba(0,0,0,0.3)',
            animation: 'scaleIn 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              marginBottom: '20px'
            }}>
              <div style={{
                width: '32px',
                height: '32px',
                background: '#fef3c715',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <AlertCircle size={18} color="#f59e0b" />
              </div>
              <h3 style={{
                margin: 0,
                fontSize: isMobile ? '18px' : '20px',
                fontWeight: '700',
                color: '#1e293b'
              }}>
                Cambio de nombre detectado
              </h3>
            </div>
            
            <p style={{
              fontSize: '14px',
              color: '#64748b',
              marginBottom: '24px',
              lineHeight: '1.5'
            }}>
              Este proveedor tiene {opcionesEdicion?.impacto?.cambios?.total_cambios || 0} cambio(s) asociado(s). ¿Cómo quieres aplicar el cambio?
            </p>

            <div style={{
              display: 'grid',
              gap: '12px',
              marginBottom: '24px'
            }}>
              <button
                onClick={() => ejecutarOpcionEdicion('incluir_pasados')}
                disabled={guardando}
                style={{
                  padding: '14px 16px',
                  border: '2px solid #3b82f6',
                  borderRadius: '10px',
                  background: '#eff6ff',
                  color: '#3b82f6',
                  fontSize: '14px',
                  fontWeight: '600',
                  cursor: guardando ? 'not-allowed' : 'pointer',
                  transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  opacity: guardando ? 0.6 : 1
                }}
                onMouseEnter={(e) => !guardando && (e.target.style.background = '#dbeafe')}
                onMouseLeave={(e) => !guardando && (e.target.style.background = '#eff6ff')}
              >
                <CheckCircle2 size={16} />
                Incluir Pasados
              </button>
              <button
                onClick={() => ejecutarOpcionEdicion('solo_futuros')}
                disabled={guardando}
                style={{
                  padding: '14px 16px',
                  border: '2px solid #f59e0b',
                  borderRadius: '10px',
                  background: '#fffbeb',
                  color: '#f59e0b',
                  fontSize: '14px',
                  fontWeight: '600',
                  cursor: guardando ? 'not-allowed' : 'pointer',
                  transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  opacity: guardando ? 0.6 : 1
                }}
                onMouseEnter={(e) => !guardando && (e.target.style.background = '#fef3c7')}
                onMouseLeave={(e) => !guardando && (e.target.style.background = '#fffbeb')}
              >
                <AlertCircle size={16} />
                Solo Futuros
              </button>
              <button
                onClick={() => ejecutarOpcionEdicion('crear_nuevo')}
                disabled={guardando}
                style={{
                  padding: '14px 16px',
                  border: '2px solid #10b981',
                  borderRadius: '10px',
                  background: '#ecfdf5',
                  color: '#10b981',
                  fontSize: '14px',
                  fontWeight: '600',
                  cursor: guardando ? 'not-allowed' : 'pointer',
                  transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  opacity: guardando ? 0.6 : 1
                }}
                onMouseEnter={(e) => !guardando && (e.target.style.background = '#d1fae5')}
                onMouseLeave={(e) => !guardando && (e.target.style.background = '#ecfdf5')}
              >
                <Plus size={16} />
                Crear Nuevo
              </button>
            </div>

            <div style={{
              display: 'flex',
              justifyContent: 'center'
            }}>
              <button
                onClick={() => setShowModal3Opciones(false)}
                disabled={guardando}
                style={{
                  padding: '10px 20px',
                  border: '2px solid #e2e8f0',
                  borderRadius: '10px',
                  background: 'white',
                  color: '#64748b',
                  fontSize: '14px',
                  fontWeight: '600',
                  cursor: guardando ? 'not-allowed' : 'pointer',
                  transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                  opacity: guardando ? 0.6 : 1
                }}
                onMouseEnter={(e) => !guardando && (e.target.style.background = '#f8fafc')}
                onMouseLeave={(e) => !guardando && (e.target.style.background = 'white')}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}

      {showDeleteModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000,
          padding: isMobile ? '20px' : '0',
          animation: 'fadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
        }}>
          <div style={{
            background: 'white',
            borderRadius: '16px',
            padding: isMobile ? '20px' : '24px',
            width: isMobile ? '100%' : '500px',
            maxWidth: '90vw',
            maxHeight: '90vh',
            overflowY: 'auto',
            boxShadow: '0 25px 80px rgba(0,0,0,0.3)',
            animation: 'scaleIn 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '24px'
            }}>
              <h3 style={{
                fontSize: isMobile ? '18px' : '20px',
                fontWeight: '700',
                color: '#1e293b',
                margin: 0
              }}>
                Confirmar Eliminación
              </h3>
              <button
                onClick={() => setShowDeleteModal(false)}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '24px',
                  cursor: 'pointer',
                  color: '#64748b',
                  width: '32px',
                  height: '32px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '6px',
                  transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = '#f1f5f9';
                  e.target.style.color = '#374151';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'none';
                  e.target.style.color = '#64748b';
                }}
              >
                ×
              </button>
            </div>

            <div style={{ marginBottom: '24px' }}>
              <p style={{
                fontSize: '14px',
                color: '#64748b',
                marginBottom: '16px',
                lineHeight: '1.5'
              }}>
                ¿Estás seguro de eliminar el proveedor "{proveedorSeleccionado?.nombre}"?
              </p>
              
              <div style={{
                background: '#fef2f2',
                borderRadius: '12px',
                padding: '16px',
                marginBottom: '16px',
                border: '1px solid #fecaca'
              }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  marginBottom: '12px'
                }}>
                  <AlertTriangle size={16} color="#ef4444" />
                  <span style={{ fontSize: '14px', fontWeight: '600', color: '#ef4444' }}>
                    Registros asociados:
                  </span>
                </div>
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: '8px'
                }}>
                  <span style={{ fontSize: '14px', color: '#64748b' }}>Cambios:</span>
                  <span style={{ fontSize: '14px', fontWeight: '600', color: '#1e293b' }}>
                    {analisisImpacto?.cambios?.total_cambios || 0}
                  </span>
                </div>
              </div>

              <p style={{
                fontSize: '14px',
                color: '#64748b',
                lineHeight: '1.5'
              }}>
                Los registros mantendrán la referencia al proveedor, pero no se podrán crear nuevos registros con este proveedor.
              </p>
            </div>

            <div style={{
              display: 'flex',
              gap: '12px',
              justifyContent: 'flex-end'
            }}>
              <button
                onClick={() => setShowDeleteModal(false)}
                disabled={guardando}
                style={{
                  padding: '12px 20px',
                  border: '2px solid #e2e8f0',
                  borderRadius: '10px',
                  background: 'white',
                  color: '#64748b',
                  fontSize: '14px',
                  fontWeight: '600',
                  cursor: guardando ? 'not-allowed' : 'pointer',
                  transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                  opacity: guardando ? 0.6 : 1
                }}
                onMouseEnter={(e) => !guardando && (e.target.style.background = '#f8fafc')}
                onMouseLeave={(e) => !guardando && (e.target.style.background = 'white')}
              >
                Cancelar
              </button>
              <button
                onClick={ejecutarEliminacion}
                disabled={guardando}
                style={{
                  padding: '12px 20px',
                  border: 'none',
                  borderRadius: '10px',
                  background: guardando ? '#9ca3af' : 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
                  color: 'white',
                  fontSize: '14px',
                  fontWeight: '600',
                  cursor: guardando ? 'not-allowed' : 'pointer',
                  transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                  boxShadow: guardando ? 'none' : '0 4px 16px rgba(239, 68, 68, 0.25)',
                  transform: guardando ? 'none' : 'translateY(0)'
                }}
                onMouseEnter={(e) => !guardando && (e.target.style.transform = 'translateY(-1px)')}
                onMouseLeave={(e) => !guardando && (e.target.style.transform = 'translateY(0)')}
                onMouseDown={(e) => !guardando && (e.target.style.transform = 'translateY(0)')}
                onMouseUp={(e) => !guardando && (e.target.style.transform = 'translateY(-1px)')}
              >
                {guardando ? 'Eliminando...' : 'Eliminar'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}


